<template>
  <div class="batch-setting">
    <Modal v-model="show" width="960" title="提示">
      <div class="modal-main">
        <p>
          处理成功：<span style="color: #02d77d">{{ successNum }}</span>
          个，失败：<span style="color: red">{{ failNum }}</span>
          个
        </p>
        <h2 style="padding: 10px 0 4px">处理失败的账单信息</h2>
        <ul>
          <li v-for="(item, index) in failData" :key="index">
            {{ item.orgName }}（账单ID :{{ item.statementId }}）
            <span style="color: red">原因：{{ item.failStr }}</span>
          </li>
        </ul>
      </div>
      <div slot="footer">
        <Button type="primary" @click="handleOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
export default {
  data() {
    return {
      show: false,
      taskId: '',
      tableData: [],
      successNum: 0,
      failNum: 0,
      failData: []
    }
  },
  methods: {
    handleShow(id) {
      this.show = true
      this.taskId = id
      this.getTaskStatusList()
    },
    async getTaskStatusList() {

      const params = {
        busiCode: 13, //  业务编码 13 
        pageSize: 100,
        pageNo: 1,
        // busiObjIds: [],
        upBatchIds: this.taskId ? [this.taskId] : [], // 父级任务id
        procStsList: this.taskId ? [0, 1, 2, 3] : [0, 1, 2, 3],
        exeFlag: 1
      };
      this.$Spin.show();
      const res = await courseSchedulCenter.getTaskStatusListApi(params);
      this.$Spin.hide();
      if (res.status == 200) {
        this.tableData = res.message.list.map(item => {
          return { ...item.properties, procSts: item.batchProcData.procSts, failStr: item.batchProcData.lineData3 }
        })
        this.successNum = this.tableData.filter(item => {
          return item.procSts == 1
        }).length
        this.failData = this.tableData.filter(item => {
          return item.procSts == 3
        })
        this.failNum = this.failData.length
      }
      this.$emit('on-success')

    },
    handleOk() {
      this.show = false
    },
    handleCancel() {

    }
  }
}
</script>

<style>
</style>